import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=0797a8a8&scoped=true&"
import script from "./Submissions.vue?vue&type=script&lang=ts&"
export * from "./Submissions.vue?vue&type=script&lang=ts&"
import style0 from "./Submissions.vue?vue&type=style&index=0&id=0797a8a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0797a8a8",
  null
  
)

export default component.exports